import React from "react";

export const Error: React.FC<{ message?: string }> = (props) => {
  return <p>{props.message || props.children || "Error"}</p>;
};

export default Error;
